import React from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import {Toaster} from 'react-hot-toast';
import {AuthProvider} from './contexts/AuthContext';
import {PhaseProvider} from './contexts/PhaseContext';
import {ProtectedRoute} from './components/auth/ProtectedRoute';
import {PublicRoute} from './components/auth/PublicRoute';
import {Layout} from './components/layout/Layout';
import PhaseBanner from './components/PhaseBanner';

// Auth pages
import {Login} from './pages/auth/Login';
import {Register} from './pages/auth/Register';

// Main app pages
import {Home} from './pages/Home';
import {Dashboard, Upload, Voting, Matches, MatchDetail, Profile, MyArt, ArtDetail, Settings} from './pages/Dashboard';
import AdminInvitations from './pages/AdminInvitations';
import AdminPhases from './pages/AdminPhases';

// Error pages
import {NotFound} from './pages/NotFound';
import {ErrorBoundary} from './components/common/ErrorBoundary';

import './App.css';

function App() {
    return (
        <ErrorBoundary>
            <AuthProvider>
                <PhaseProvider>
                    <Router>
                        <div className="App">
                            <Toaster
                                position="bottom-right"
                                toastOptions={{
                                    duration: 4000,
                                    style: {
                                        background: '#363636',
                                        color: '#fff',
                                    },
                                    success: {
                                        iconTheme: {
                                            primary: '#10b981',
                                            secondary: '#fff',
                                        },
                                    },
                                    error: {
                                        iconTheme: {
                                            primary: '#ef4444',
                                            secondary: '#fff',
                                        },
                                    },
                                }}
                            />

                            <Layout>
                                <PhaseBanner />
                                <Routes>
                                    {/* Public routes */}
                                    <Route
                                        path="/"
                                        element={
                                            <PublicRoute>
                                                <Home />
                                            </PublicRoute>
                                        }
                                    />
                                    <Route
                                        path="/login"
                                        element={
                                            <PublicRoute>
                                                <Login />
                                            </PublicRoute>
                                        }
                                    />
                                    <Route
                                        path="/register"
                                        element={
                                            <PublicRoute>
                                                <Register />
                                            </PublicRoute>
                                        }
                                    />

                                    {/* Protected routes */}
                                    <Route
                                        path="/dashboard"
                                        element={
                                            <ProtectedRoute>
                                                <Dashboard />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path="/upload"
                                        element={
                                            <ProtectedRoute>
                                                <Upload />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path="/voting"
                                        element={
                                            <ProtectedRoute>
                                                <Voting />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path="/matches"
                                        element={
                                            <ProtectedRoute>
                                                <Matches />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path="/matches/:id"
                                        element={
                                            <ProtectedRoute>
                                                <MatchDetail />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path="/profile"
                                        element={
                                            <ProtectedRoute>
                                                <Profile />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path="/profile/:id"
                                        element={
                                            <ProtectedRoute>
                                                <Profile />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path="/my-art"
                                        element={
                                            <ProtectedRoute>
                                                <MyArt />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path="/art/:id"
                                        element={
                                            <ProtectedRoute>
                                                <ArtDetail />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path="/settings"
                                        element={
                                            <ProtectedRoute>
                                                <Settings />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path="/admin/invitations"
                                        element={
                                            <ProtectedRoute>
                                                <AdminInvitations />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path="/admin/phases"
                                        element={
                                            <ProtectedRoute>
                                                <AdminPhases />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* 404 route */}
                                    <Route path="*" element={<NotFound />} />
                                </Routes>
                            </Layout>
                        </div>
                    </Router>
                </PhaseProvider>
            </AuthProvider>
        </ErrorBoundary>
    );
}

export default App;
